import { CSSProperties } from 'react';
import { Button as AriaButton } from 'react-aria-components';

import { createBEMClasses } from '@/utils/classname';

import './Badge.css';

const { block, element } = createBEMClasses('badge');

interface BadgeProps {
  size?: 'x-small' | 'small' | 'large' | 'x-large';
  color?:
    'neutral' | 'neutral-reversed' | 'primary' | 'danger' | 'secondary' | 'warning' | 'tertiary';
  hasBorder?: boolean;
  borderRadius?: 'soft' | 'full';
  iconOnly?: boolean;
  noHoverShadow?: boolean;
  noWrap?: boolean;
  onClick?: () => void;
  children: React.ReactNode;
  className?: string;
  style?: CSSProperties;
}

const Badge = ({
  size = 'small',
  color = 'neutral',
  hasBorder = false,
  borderRadius = 'full',
  iconOnly = false,
  noHoverShadow = false,
  noWrap = false,
  onClick,
  children,
  className: additionalClassName,
  style,
}: BadgeProps) => {
  const className = block(
    {
      size,
      color,
      'has-border': hasBorder,
      'border-radius': borderRadius,
      'icon-only': iconOnly,
      'no-hover-shadow': noHoverShadow,
      'no-wrap': noWrap,
      clickable: !!onClick,
    },
    additionalClassName
  );

  const contentClassName = element('content', { size });

  if (onClick) {
    return (
      <AriaButton id="" className={className} onPress={onClick} style={style}>
        <div className={contentClassName}>{children}</div>
      </AriaButton>
    );
  }

  return (
    <div className={className} style={style}>
      <div className={contentClassName}>{children}</div>
    </div>
  );
};

export default Badge;
